import React from 'react';
import $ from 'jquery';
import  Navbar from './cmp/Navbar.js';
import About from './cmp/About.js';
import  Home from './cmp/Home.js';
import  Accomodations from './cmp/Accomodations.js';
import  Offers from './cmp/Offers.js';
import  WeddingEvents from './cmp/WeddingEvents.js';
import  Dining from './cmp/Dining.js';
import  Contact from './cmp/Contact.js';
import  Footer from './cmp/Footer.js';
import { BrowserRouter as Router, Routes,Route, Link } from 'react-router-dom';



function App() {
  
  return (
    <div className="App">
        <Router>
            <Navbar></Navbar>
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/about' element={<About />} />
                    <Route path='/accomodations' element={<Accomodations />} />
                    <Route path='/offers' element={<Offers />} />
                    <Route path='/weddingevents' element={<WeddingEvents />} />
                    <Route path='/dining' element={<Dining />} />
                    <Route path='/contact' element={<Contact />} />
                </Routes>
            <Footer></Footer>
        </Router>
       
      
      
    </div>
  );
}

export default App;
